export const Sign_In_Event = "Analytics_Successful_SignIn";
export const Sign_Up_Event = "Analytics_Successful_SignUp";
export const Sign_Out_Event = "Analytics_Successful_SignOut";

export const View_Item_Event = "Analytics_View_Item";
export const View_Cart_Event = "Analytics_View_Cart";
export const Begin_Checkout_Event = "Analytics_Begin_Checkout";

export const ADD_Flight_Event = "Analytics_Add_Flight";
export const Queue_Wait_Time_Event = "Analytics_Queue_Wait_Time";

export const View_T1_Map_Event = "Analytics_View_T1_Map";
